module.exports = __webpack_public_path__ + "img/local_hospital_management.b28eb505.png";